"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHoseCodesFromDiastereotopicID = getHoseCodesFromDiastereotopicID;
const ensureHeterotopicChiralBonds_js_1 = require("../diastereotopic/ensureHeterotopicChiralBonds.js");
const getHoseCodesForAtomsInternal_js_1 = require("./getHoseCodesForAtomsInternal.js");
/**
 * Returns the hose code for a specific marked atom
 * @param {import('openchemlib').Molecule} molecule
 * @param {object} options
 */
function getHoseCodesFromDiastereotopicID(molecule, options = {}) {
    molecule.addImplicitHydrogens();
    (0, ensureHeterotopicChiralBonds_js_1.ensureHeterotopicChiralBonds)(molecule);
    return (0, getHoseCodesForAtomsInternal_js_1.getHoseCodesForAtomsInternal)(molecule, options);
}
//# sourceMappingURL=getHoseCodesFromDiastereotopicID.js.map